import './menu_section_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  static classes = ['expanded', 'empty', 'collapsible', 'uncollapsed']

  connect = (): void => {
    this.toggleEmpty()
  }

  toggleExpand = (): void => {
    if (this.expanded) {
      this.element.classList.remove(this.expandedClass)
    } else {
      this.element.classList.add(this.expandedClass)
    }
  }

  toggleEmpty = (): void => {
    if (this.empty) {
      this.element.classList.add(this.emptyClass)
    } else {
      this.element.classList.remove(this.emptyClass)
    }
  }

  toggleCollapse = (): void => {
    this.filtersController.toggle()
    if (this.element.classList.contains(this.uncollapsedClass)) {
      this.element.classList.remove(this.uncollapsedClass)
    } else {
      this.element.classList.add(this.uncollapsedClass)
    }
  }

  resize = (offset: number): void => {
    this.element.style.width = `calc(100% - ${offset}px)`
  }

  get elastic (): boolean {
    return this.element.dataset.menuTarget === 'elastic'
  }

  get overflowingContent (): boolean {
    return this.innerWidth > this.outerWidth
  }

  get expanded (): boolean {
    return this.element.classList.contains(this.expandedClass)
  }

  get outerWidth (): number {
    return this.element.offsetWidth
  }

  get innerWidth (): number {
    let width: number = 0
    for (const child of this.element.children) {
      width += parseInt(child.offsetWidth)
    }
    return width
  }

  get empty (): boolean {
    return this.innerWidth === 0
  }

  get navigationController (): object {
    return this.application.getControllerForElementAndIdentifier(this.element.closest('.navigation'), 'navigation')
  }

  get filtersController (): object {
    return this.navigationController.filtersController
  }
}
